import { provideZoneChangeDetection } from "@angular/core";
/// <reference types="@angular/localize" />

import {bootstrapApplication} from "@angular/platform-browser";
import {AppComponent} from "./app/app";
import { appConfig, pca } from './app/app.config';

(async () => {
  await pca.initialize();

  try {
    const result = await pca.handleRedirectPromise();
    if (result?.account) {
      pca.setActiveAccount(result.account);
    } else {
      const accs = pca.getAllAccounts();
      if (accs.length && !pca.getActiveAccount()) {
        pca.setActiveAccount(accs[0]);
      }
    }
  } catch {
    // ignore
  }

  await bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch(err =>
    console.error(err)
  );
})();
